export default __webpack_public_path__ + "static/media/concierge.d745f32b.png";